module.exports = __webpack_public_path__ + "img/gallery10-1.d05210c9.jpg";